import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { useAuth } from "../context/AuthContext";
import { useDepot } from "../context/DepotContext";

export function DepotField({ value, onChange, label = "Depot", testid = "depot-field", exclude, alwaysSelect = false }) {
  const { isAdmin } = useAuth();
  const { depots, depotName } = useDepot();
  return (
    <div className="space-y-1.5">
      <Label className="label-mono">{label}</Label>
      {!isAdmin && !alwaysSelect ? (
        <div data-testid={testid} className="flex h-10 items-center rounded-md border border-slate-800 bg-slate-950/50 px-3 text-sm text-slate-300">
          {depotName(value)}
        </div>
      ) : (
        <Select value={value || ""} onValueChange={onChange}>
          <SelectTrigger data-testid={testid} className="bg-slate-950">
            <SelectValue placeholder="Select depot" />
          </SelectTrigger>
          <SelectContent>
            {depots.filter((d) => d.id !== exclude).map((d) => (
              <SelectItem key={d.id} value={d.id} data-testid={`${testid}-option-${d.code}`}>{d.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  );
}

export function SimpleSelect({ label, value, onChange, options, testid }) {
  return (
    <div className="space-y-1.5">
      <Label className="label-mono">{label}</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid={testid} className="bg-slate-950">
          <SelectValue placeholder="Select" />
        </SelectTrigger>
        <SelectContent>
          {options.map((o) => (
            <SelectItem key={o} value={o} data-testid={`${testid}-option-${o.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{o}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
